import { Chip } from '@material-ui/core';
import React from 'react';

// @ts-ignore — plain JS module without type declarations
import { CopyField as CopyFieldUntyped } from './CopyField';

// Plain JS component: TS infers `source` as required though it is optional
const CopyField: any = CopyFieldUntyped;

const ORDER_LINK_COLOR = '#3f51b5';

interface OrderReferenceChipProps {
  orderId: number;
  reference?: string | null;
}

export const OrderReferenceChip: React.FC<OrderReferenceChipProps> = ({ orderId, reference }) => (
  <CopyField value={reference || String(orderId)} copyByIcon iconPosition="right">
    <a
      href={`#/orders/${orderId}/show`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      <Chip label={reference || `#${orderId}`} size="small" clickable style={{ color: ORDER_LINK_COLOR }} />
    </a>
  </CopyField>
);
